import { useAuth } from '@polvo-labs/react-auth'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { setTimeout } from 'timers'
import Form from '../../components/Form'
import routes from '../../config/routes'
import isCommon from '../../utils/is-common'
import fields, { LoginFormData } from './fields'

const LoginForm: React.FC = () => {
  const { login } = useAuth()
  const history = useHistory()

  return (
    <Form<LoginFormData>
      buttonLabel="ENTRAR"
      fields={fields}
      onSubmit={({ email, password }) => {
        return login!(email, password, {}).then(({ user }) => {
          // toast.success('Logado com sucesso')
          if (isCommon(user)) {
            // if(!user.verified){
            //   setTimeout(()=>{
            //     history.push(routes.account_activation.path)
            //   }, 0)
            // }else
            // {setTimeout(()=>{
            //   history.push(routes.admin.index.path)
            // }, 0)}
          } else {
            setTimeout(()=>{
              history.push(routes.index.path)
            }, 0)            
          }
        }).catch(err => {
          if (err?.response?.data?.error_description === 'The user credentials were incorrect.') {
            toast.error('Email e/ou senha incorretos')
          } else {
            toast.error('Ocorreu um erro desconhecido')
          }
        })
      }}
    />
  )
}

export default LoginForm
